import { api } from "./configs/axiosConfigs"

export const AccountReceivableAPI = {
    get: async (data?: object) => {
        const response = await api.get(
            '/account-receivable', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    create: async (data: object) => {
        const response = await api.post(
            '/account-receivable/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    pay: async (data: object) => {
        const response = await api.post(
            '/account-receivable/pay', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    getExcel: async (id: number) => {
        const response = await api.get(
            '/account-receivable/excel/' + id,
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getPDF: async (id: number) => {
        const response = await api.get(
            '/account-receivable/pdf/' + id,
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
}